import { createContext, Dispatch, SetStateAction } from "react";
import type events from "analytics/events";
import type {
  ExtraLoginParams,
  ModifiedAnalyticsType,
} from "@shared/analytics/types";

export const AnalyticsContext = createContext<{
  analytics: ModifiedAnalyticsType<typeof events> | undefined;
  deferredAnalytics?: ModifiedAnalyticsType<typeof events>;
  setIsInitialized?: Dispatch<SetStateAction<boolean>>;
  setExtraLoginParams?: (extraParams: ExtraLoginParams) => void;
}>({ analytics: undefined });
